import { render } from "./TopNavBar.vue?vue&type=template&id=3b775d0b&scoped=true"
import script from "./TopNavBar.vue?vue&type=script&lang=js"
export * from "./TopNavBar.vue?vue&type=script&lang=js"

import "./TopNavBar.vue?vue&type=style&index=0&id=3b775d0b&scoped=true&lang=css"

import exportComponent from "/builds/2022/tjusls-china/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b775d0b"]])

export default __exports__